
export default {
props:{
  alertErrorDesempregado: {
    type: Boolean,
    default: false
  },
  onClose: {
    type: Function
  }
}
}
